module.exports = __webpack_public_path__ + "img/1511178862.49a069e5.jpg";